export default __webpack_public_path__ + "static/media/whatsapp_white.b2a7b629.svg";